<template>
  <section>
    <div v-if="GETmsglog.true_msg === true" class="modal2ft"></div>
    <div class=" disflex">
      <div
        class="psf  fy-top_0 fy-height_100p fy-padding-b-50"
        :class="{
          'fy-width_70p  ': GETscreen === 'desktop',
          'fy-width_100p': GETscreen === 'mobile'
        }"
        style="overflow-y:scroll"
      >
        <div
          class="  fy-border_r12 psr fy-padding-10"
          :class="{
            'fy-width_400cointainer fy-margin-t-70 fy-login_box_shadow':
              GETscreen === 'desktop',
            'fy-width_100p fy-margin-t-30': GETscreen === 'mobile'
          }"
          style="contain:content"
        >
          <div
            v-if="GETmsglog.true_msg === true && GETscreen === 'desktop'"
            class="fy-linear_load2 psa fy-width_100p"
          ></div>

          <div class="fy-portlet-body">
            <div class="fy-padding-5 tac ">
              <div class="fy-ts  fy-main_logo" style="font-size:50px">
                <simplelogo :options="{ width: 170, height: 82 }" />
              </div>
            </div>
            <div v-if="GETscreen === 'mobile'" class="fy-width_100p tac">
              <div
                @click="signup"
                class="fy-fit_width fy-logout_btn  disflex fy-padding-5 fy-height_50px fy-portlet-active--br fy-border_r12"
              >
                <div class=" fy-padding-5 tac fy-width_100p">
                  <span class="fy-ts fy-font-18">Register</span>
                </div>
              </div>
            </div>
            <div
              class="fy-padding-t-15 tac fy-padding-b-15"
              v-if="
                GETmsglog.email_msg === true ||
                  GETmsglog.password_msg === true ||
                  GETmsglog.true_msg === true
              "
            >
              <div
                v-if="GETmsglog.email_msg === true"
                class=" fy-danger_bg fy-fit_width fy-portlet-active--br danger fy-ff-wp  fy-padding-r-10 fy-padding-l-10 fy-padding-t-5 fy-padding-b-5 disflex fy-border_r12"
              >
                <div class="fy-padding-5 fy-font-20">
                  <icons
                    class="fy-margin-t-1"
                    excel="warning"
                    routerActive="false"
                    hoverActive="false"
                    message="Grew"
                    color="red"
                    width="21"
                    height="21"
                  />
                </div>
                <div class="fy-font-18 fy-text-1 fy-padding-5">
                  Email is Incorrect.
                </div>
              </div>

              <div
                v-if="GETmsglog.password_msg === true"
                class=" fy-danger_bg fy-fit_width fy-portlet-active--br danger fy-ff-wp  fy-padding-r-10 fy-padding-l-10 fy-padding-t-5 fy-padding-b-5 disflex fy-border_r12"
              >
                <div class="fy-padding-5 fy-font-20">
                  <icons
                    class="fy-margin-t-1"
                    excel="warning"
                    routerActive="false"
                    hoverActive="false"
                    message="Grew"
                    color="red"
                    width="21"
                    height="21"
                  />
                </div>
                <div class="fy-font-18 fy-text-1 fy-padding-5">
                  Password is Incorrect.
                </div>
              </div>

              <div
                v-if="GETmsglog.true_msg === true"
                class="  fy-green_bg fy-fit_width fy-portlet-active--br fy-text-1 fy-ff-wp  fy-padding-r-10 fy-padding-l-10 fy-padding-t-5 fy-padding-b-5 disflex fy-border_r12"
              >
                <div class="fy-padding-5 fy-font-20">
                  <icons
                    class="fy-margin-t-4"
                    excel="check"
                    routerActive="false"
                    hoverActive="false"
                    message="Grew"
                    color="lime"
                    width="21"
                    height="21"
                  />
                </div>
                <div class="fy-font-18 fy-padding-5">Logged in.</div>
              </div>
            </div>
            <div
              :class="{
                'fy-padding-l-15 fy-padding-r-15': GETscreen === 'desktop'
              }"
            >
              <div class="fy-input_holder fy-margin-t-20">
                <input
                  @keydown.enter="btr(0)"
                  ref="email"
                  type="text"
                  v-model="email"
                  placeholder="Email "
                  class="fy-input_normal fy-border_r8 fy-pos_rel disflex fy-padding-l-15 fy-padding-r-15
fy-padding-t-10 fy-padding-b-10 fy-font-18 fy-ff-wp	 fy-input_carset fy-width_100p fy-main_input   "
                />
              </div>

              <div class="fy-input_holder psr fy-margin-t-20">
                <input
                  @keydown.enter="btr(1)"
                  ref="password"
                  v-model="password"
                  placeholder="Password "
                  class="fy-input_normal fy-border_r8 fy-pos_rel disflex fy-padding-l-15 fy-padding-r-45
fy-padding-t-10 fy-padding-b-10 fy-font-18 fy-ff-wp	 fy-input_carset  fy-width_100p fy-main_input   "
                  v-bind:class="{
                    '': ptype === false,
                    'fy-word_security': ptype === true
                  }"
                />
                <div
                  class="psa fy-height_100p fy-padding-5 fy-top_0 fy-right_0 fy-text-1 fy-font-20"
                >
                  <div @click="p_type" class="fy-cursor_point">
                    <div class=" fy-padding-t-5">
                      <icons
                        v-if="ptype === false"
                        class=""
                        excel="eye"
                        routerActive="false"
                        hoverActive="false"
                        message="Grew"
                        color="var(--fy-font-applyed-7)"
                        width="25"
                        height="25"
                      />
                      <icons
                        v-else
                        class=""
                        excel="eyeSlash"
                        routerActive="false"
                        hoverActive="false"
                        message="Grew"
                        color="var(--fy-font-applyed-7)"
                        width="25"
                        height="25"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              class="fy-margin-t-20 disflex fy-width_100p fy-jc_Sb fy-margin-b-30"
            >
            <!--  <template>
                <div
                  id="g_id_onload"
                  data-client_id="1000111464937-ekh67k36qtn6i2ae2fcg85mqbhidpbk1.apps.googleusercontent.com"
                  data-ux_mode="redirect"
                  data-login_uri="http://localhost:3000"
                ></div>
                <div class="g_id_signin" data-type="standard"></div>
              </template> -->

              <div class="fy-width_100p tae fy-padding-l-30 fy-padding-r-30">
                <div class=" ">
                  <button
                    @click="login"
                    :disabled="
                      email.length === 0 ||
                        password.length === 0 ||
                        b_loading === true
                    "
                    class="btn btn-info"
                  >
                    <div
                      v-if="b_loading === true"
                      class="psr fy-height_25px  fy-width_100p"
                    >
                      <div class="fy-submit_loading"></div>
                    </div>
                    <span v-else>Login</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class=" fy-portlet-active--bg fy-margin-t-50 fy-padding-l-5 fy-padding-r-5 fy-height_100px"
          :class="{
            'fy-width_100p': GETscreen === 'mobile',
            'fy-width_60p fy-login_box_shadow  fy-border_r12  fy-margin-l-20p':
              GETscreen === 'desktop'
          }"
        >
          <div class="fy-width_100p fy-height_100p psr">
            <div
              class="psa fy-top_0 fy-width_100p fy-height_15px fy-margin-t-2 fy-right_0"
              style="border-bottom:1px solid var(--fy-space-rve-25); "
            ></div>
            <div v-if="void 0 === 1" class="fy-width_100p fy-height_100p psa fy-top_0 fy-right_0">
              <div class="tac fy-width_100p fy-padding-2 fy-text-7 fy-font-18">
                <span
                  class="fy-padding-l-10 fy-padding-r-10 fy-portlet-active--bg"
                  >More</span
                >
              </div>
              <div
                v-if="googleEntryLoading === true"
                class="fy-padding-2 tac fy-width_100p fy-height_60px "
              >
                <flowerLoading
                  dimension="50"
                  class="fy-margin-t-5"
                  color="var(--fy-space-rve-75)"
                />
              </div>
              <div v-else class="fy-padding-2 tac fy-width_100p">
                <embed
                  style="overflow:hidden"
                  class="fy-height_60px"
                  :src="`${GETapilink}google/Login/credentials`"
                />
              </div>
            </div>
          </div>
        </div>
        <div
          class="fy-width_100p   fy-padding-5 "
          :class="{ 'fy-padding-l-10': GETscreen === 'desktop' }"
        >
          <div
            class="fy-ts fy-margin-t-30 fy-text-1 tac fy-font-23"
            v-if="GETscreen === 'mobile'"
          >
            Here you can compete others and measure your activity.
          </div>

          <about class="fy-margin-t-100" />

          <div
            v-if="GETscreen === 'mobile'"
            class="disflex fy-jc_sb fy-width_100p tac fy-margin-t-100 fy-padding-l-80 fy-padding-r-80"
          >
            <div>
              <div>
                <a
                  class="fy-dis_inl fy-link_m fy-text-7"
                  href="https://about.fyish.com"
                  target="_blank"
                  >About</a
                >
              </div>
            </div>

            <div>
              <div>
                <a
                  class="fy-dis_inl fy-link_m fy-text-7"
                  href="https://about.fyish.com/terms"
                  target="_blank"
                  >Terms</a
                >
              </div>
            </div>
            <div>
              <div>
                <a
                  class="ffy-dis_inl fy-link_m fy-text-7"
                  href="https://about.fyish.com/policies"
                  target="_blank"
                  >Policy</a
                >
              </div>
            </div>
          </div>

          <div
            class="fy-footer__copyright fy-margin-t-30 fy-width_100p tac"
            v-if="GETscreen === 'mobile'"
          >
            <a
              href="https://about.fyish.com"
              class="fy-font-14 fy-text-1 fy-ts "
            >
              &copy; &nbsp; FYISSH.INC&nbsp;&nbsp;2020-2022</a
            >
          </div>
        </div>

        <!-- <div v-if="!true_msg " class="fy-width_100p disflex fy-padding-10 fy-margin-t-30" style=" height:190px; overflow:scroll">
	
	<div class="tac fy-padding-20 fy-padding-b-50 fy-portlet-active--bg fy-height_auto fy-margin-r-20 fy-portlet-active--br fy-border_r12" style="width:160px">

	<div  class="fy-widget__label fy-font-25 " style="color: var(--fyissh-main-logo);"><svg height="30px" viewBox="0 -20 512 512" width="30px" xmlns="http://www.w3.org/2000/svg"><path d="m119 161c-22.054688 0-40 17.945312-40 40v151c0 22.054688 17.945312 40 40 40h76c22.054688 0 40-17.945312 40-40v-151c0-22.054688-17.945312-40-40-40zm76 191h-76v-151h76l.023438 151s-.003907 0-.023438 0zm236-75c0 11.046875-8.953125 20-20 20h-116c-11.046875 0-20-8.953125-20-20s8.953125-20 20-20h116c11.046875 0 20 8.953125 20 20zm0 76c0 11.046875-8.953125 20-20 20h-116c-11.046875 0-20-8.953125-20-20s8.953125-20 20-20h116c11.046875 0 20 8.953125 20 20zm0-152c0 11.046875-8.953125 20-20 20h-116c-11.046875 0-20-8.953125-20-20s8.953125-20 20-20h116c11.046875 0 20 8.953125 20 20zm21-201h-392c-33.085938 0-60 26.914062-60 60v332c0 44.113281 35.886719 80 80 80h352c44.113281 0 80-35.886719 80-80 0-11.046875-8.953125-20-20-20s-20 8.953125-20 20c0 22.054688-17.945312 40-40 40h-352c-22.054688 0-40-17.945312-40-40v-271h432v171c0 11.046875 8.953125 20 20 20s20-8.953125 20-20v-232c0-33.085938-26.914062-60-60-60zm-81 40c11.027344 0 20 8.972656 20 20s-8.972656 20-20 20-20-8.972656-20-20 8.972656-20 20-20zm100 20c0 11.027344-8.972656 20-20 20s-20-8.972656-20-20 8.972656-20 20-20 20 8.972656 20 20zm-431 0c0-11.027344 8.972656-20 20-20h254.441406c-2.222656 6.261719-3.441406 12.988281-3.441406 20 0 7.386719 1.347656 14.460938 3.800781 21h-274.800781zm0 0"/></svg></div>
	<div class="fy-width_100p tac fy-padding-t-10 fy-ts fy-font-20 fy-text-1">Last Login.</div>
	
	
	</div>
	<div v-if ="getlogin" class="disflex">
	<div v-for ="(login, index) in getlogin" :key="index">
	<div class="disflex">
	<div   class="fy-portlet-active--bs psr fy-portlet-active--bg fy-fit_height fy-margin-r-20 fy-portlet-active--br fy-border_r12" style="width:160px">
     <button @click ="userdel(index)" class="psa fy-top_5 fy-text-4 fy-border_50 fy-q_manner fy-right_5" style="font-size:9px"><i class="flaticon2-delete"/></button>
	<img @click= "revert(index)" :src="GETapilink  +  `user/cus_profile/v1/photo/` + login.profilepic " class="fy-width_100p fy-border_r12">
	<div class =" fy-font-17 psa fy-bottom_0 fy-width_100p btmr_12 fy-text-4 tac" style="background:var(--fyissh-space-rve-50)">
	{{login.first_name}}  {{login.last_name}}
	</div>
	</div>
	</div>
	</div>
	</div>
	<div  v-else class=" fy-padding-t-60 fy-padding-l-30 fy-ts fy-text-1 fy-font-25">
	
	Welcome you are first-one to Login from this device.
	</div>
	
	
	
	
	
	</div> -->
      </div>
      <div
        v-if="GETscreen === 'desktop'"
        class="fy-width_30p fy-top_0 fy-height_100p psf  fy-auto_scroll"
        style="left:70%; border-left:1px solid #00000068"
      >
        <div class="fy-width_100p psa fy-padding-b-10" style="top:10px">
          <div class=" fy-margin-t-20 tac fy-width_100p ">
            <div
              v-ripple:asset="{ type: 'theme', size: 'big' }"
              @click="signup"
              class="fy-fit_width fy-logout_btn fy-cursor_point  disflex fy-padding-5 fy-height_60px fy-portlet-active--br fy-border_r12"
            >
              <div
                class="fy-widget__label tac"
                style="color: var(--fyissh-main-logo);"
              >
                <icons
                  class="fy-margin-t-5"
                  excel="account"
                  routerActive="false"
                  hoverActive="false"
                  message="Grew"
                  color="var(--fy-font-applyed-1)"
                  width="30"
                  height="30"
                />
              </div>
              <div
                class="fy-padding-l-20 fy-padding-r-20 fy-padding-t-10 fy-ts fy-font-20 fy-text-1"
              >
                Register Yourself.
              </div>
            </div>
          </div>

          <div
            class="tac fy-width_100p fy-margin-b-70 fy-padding-b-60 fy-padding-t-60"
          >
            <logo :options="{ width: 200, height: 180 }" />

            <div class="fy-padding-r-20 fy-padding-l-20">
              <div class="fy-ts fy-margin-t-20 fy-text-1 fy-font-24">
                Reach, the thing you are known for.
              </div>
            </div>
          </div>

          <div
            class="disflex fy-jc_sb fy-width_100p fy-padding-l-80 fy-padding-r-80"
          >
            <div>
              <div>
                <a
                  class="fy-dis_inl fy-link_m fy-text-7"
                  href="https://about.fyish.com"
                  target="_blank"
                  >About</a
                >
              </div>
            </div>

            <div>
              <div>
                <a
                  class="fy-dis_inl fy-link_m fy-text-7"
                  href="https://about.fyish.com/terms"
                  target="_blank"
                  >Terms</a
                >
              </div>
            </div>
            <div>
              <div>
                <a
                  class="fy-dis_inl fy-link_m fy-text-7"
                  href="https://about.fyish.com/policies"
                  target="_blank"
                  >Policy</a
                >
              </div>
            </div>
          </div>
          <div></div>

          <div style="display:grid;">
            <div
              class="fy-footer__copyright fy-margin-t-20 fy-margin-b-20 fy-width_100p tac"
            >
              <a
                href="https://about.fyish.com"
                class="fy-font-15 fy-text-1 fy-ts "
              >
                &copy; &nbsp; FYISSH.INC&nbsp;&nbsp;{{ year }}</a
              >
            </div>
          </div>
        </div>
      </div>
    </div>

    <div><router-view /></div>
    <div v-if="securityPanel === true">
      <teleport to="body">
        <div class="fy-width_100p fy-height_100px tac psa fy-bottom_0 fy-right_0 fy-left_0">
         <div :class="{'fy-width_100p fy-padding-5 tac fy-portlet-active--bg fy-portlet-active--bs3 fy-height_100p' : GETscreen === 'mobile',
            'fy-width_60p fy-padding-5 fy-border_r12 fy-padding-t-20 fy-padding-l-10 fy-padding-r-10 tac fy-portlet-active--bg fy-portlet-active--bs3 fy-height_100p' : GETscreen === 'desktop'}">
            <div class="fy-width_100p  disflex">
              <div style="width:calc(100% - 65px)">
                You are not authorized to sign up from here for security reasons. Email here <a href="fyisshinformation@gmail.com">fyisshinformation@gmail.com</a> and tell your purpose you will get an Email and Password to log in. 
.
              </div>
              <div class="fy-width_65px"><button @click="securityPanel = false" class="btn btn-info">Got it</button></div>
            </div>
         </div>
        </div>
        </teleport>
    </div>
  </section>
</template>
<style scoped>
.fy-log_bt {
  background: red;
  color: white;
  margin-left: 4px;
  font-size: x-large;
  border-radius: 12px;
  box-shadow: 1px 1px 3px #00000068;
}
.fy-margin-l-20p {
  margin-left: 20%;
}
</style>
<script>
import { mapGetters } from "vuex";
import about from "@/registration/about";
import Axios from "axios";
export default {
  
  data() {
    return {
      email: "",
      password: "",
      ptype: true,
      b_loading: false,
      googleEntryLoading: false,
      error: "",
      securityPanel : true,
      activeInput: "",
      activeArray: {
        email: "password",
        password: "enter"
      }
    };
  },
  components: {
    about
  },

  created() {
    if (this.$store.getters.isLoggedIn) {
      this.$router.push("/");
    }
  },
  mounted() {
    window.onmessage = a => {
      
      var t = this.GETapilink.substring(0, this.GETapilink.length - 1);
      if (a.origin === t && a.data.authoriseSupplier)
        this.signin(JSON.parse(a.data.data));
      
    };
  },
  methods: {
    btr(a) {
      var array = ["email", "password"];

      if (
        this.email.length === 0 ||
        this.password.length === 0 ||
        a != array.length - 1
      ) {
        if (a == array.length - 1) {
          var t = 0;
        } else {
          t = a + 1;
        }
        this.$refs[array[t]].focus();
      } else if (a == array.length - 1) {
        this.login();
      }
    },
    async signin(d) {
      try {
        this.googleEntryLoading = true;
        var first_name = d.given_name,
          last_name = d.family_name,
          email = d.email,
          password = "",
          year = 0,
          month = 0,
          date = 0,
          origin = 1,
          verified = true === d.email_verified ? 1 : 0,
          p = {
            email,
            first_name,
            last_name,
            password,
            date,
            month,
            year,
            origin,
            verified
          };
     
        Axios.post(`${this.GETapilink}` + "signup?request=Outside", p)
          .then(response => {
            var r = response.data;
               console.log(r);
            //  var data = response.data.access[0];

            if (r.true_msg === true) {
              this.ImageSetLocal(d.picture);
            }
            this.AuthSet(r.token, r.access[0], r.type);
          })
          .catch(e => {
            console.error(e);
          });
      } catch (e) {
        console.error(e);
      }
    },
    async ImageSetLocal(d) {
      localStorage.setItem("GoogleOauthUserImage", `${d}`);
    },
    async login() {
      this.b_loading = true;
      var email = this.email,
        password = this.password;
      this.$store.dispatch("LOADsignin", { email, password });
    },

    async userdel(index) {
      this.$store.commit("delete_last_visitors", { index });
    },
    p_type() {
      this.ptype = !this.ptype;
    },
    AuthSet(token, user, type) {
      this.$store.dispatch("login", { token, user });
      setTimeout(() => {
        if(type === "Registration"){
          this.$store.commit("SetConfirmationPage", true);
           this.$router.replace("/confirmed");
        }else{
             this.$router.replace("/");
        }
       
        this.$store.commit("Set_msg_login");
        this.googleEntryLoading = false;
      }, 2000);
    },
    async signup() {
      try {
        this.$router.push("/signup");
      } catch (e) {
        this.error = e;
      }
    },
    enable() {
      this.b_loading = false;
    }
  },
  computed: {
    ...mapGetters(["GETscreen", "GETapilink", "GETmsglog"]),
    year() {
      let d = new Date();
      return d.getFullYear();
    },
    metaInfo(){
    return "Fyish - Login & Registration"
  },
  },
  updated() {
    if (this.GETmsglog.true_msg === true) {
      var token = this.GETmsglog.token,
        user = this.GETmsglog.access[0];

      this.AuthSet(token, user);
    }
  },
  watch: {
    GETmsglog: function() {
      this.enable();
    }
  }
};
</script>
